import { Button } from "@themesberg/react-bootstrap";
import React from "react";

export const TableRow = (props) => {
  const {
    ticket,
    user,
    netValue,
    fee,
    tax,
    isPaid,
    id,
    grossValue,
  } = props.data;

  const { onPaidPress } = props;
  const numberFormatter = new Intl.NumberFormat("vn-VI", {});

  return (
    <tr>
      <td className="text-center">
        <Button onClick={() => props.onShowDetailPress(props.data)}>
          Chi tiết
        </Button>
      </td>
      <td>
        {(user && user.name) || ""}
        <br />
        <span>
          <strong className={`text-primary`}>
            {(user && user.phone) || ""}
          </strong>
        </span>
      </td>
      <td className="text-center">{ticket.cartId}</td>
      <td className="text-center">
        {ticket.Channel.name}
        <br />
        {ticket.resultDate}
      </td>
      <td className="text-center">
        {ticket.LotoType}<br />
        {ticket.numbers}<br />
        {new Intl.NumberFormat('vn-VI', {}).format(ticket.value)}
      </td>
      <td className="text-center text-success">{numberFormatter.format(grossValue || 0)}</td>
      <td className="text-center">{numberFormatter.format(tax || 0)}</td>
      <td className="text-center">{numberFormatter.format(fee || 0)}</td>
      <td className="text-center text-primary">{numberFormatter.format(netValue || 0)}</td>
      <td className="text-center text-success">
        {isPaid ? (
          "Đã trả thưởng"
        ) : (
          <Button
            className="btn-danger m-1"
            onClick={() => onPaidPress(id, user.phone, ticket.id)}
          >
            Trả thưởng
          </Button>
        )}
      </td>
    </tr>
  );
};